<template>
    <div :class="$style.detail">
      <div :class="$style.box">
        <p
          :class="$style.content"
          style="white-space: pre-wrap;"
        >
        {{detailContent[0] && detailContent[0].doc}}
        </p>
      </div>
    </div>
  </template>
  
  <script>
  
  import { setPageTitle, setRightTxt } from '@/bridge/AppJsBridge';
  import { getBtActRule } from "@/apis/btBoxActivity";
  
  export default {
    data() {
      return {
        detailTitle: "活动规则",
        detailContent: [],
      };
    },
    created() {
      this.initData();
      setRightTxt(' ')
    },
    methods: {
      async initData() {
        let type = 4;
        const { history } = this.$router;
        const {params} = history.current;
        if (params.type) {
          type = params.type;
        }
        setPageTitle(this.detailTitle);
        getBtActRule({type}).then(res => {
            this.detailContent = res.data;
        })
      },
      goBack() {
        this.$router.back()
      },
    },
  };
  </script>
  
  <style lang="scss" module>
  .detail {
    width: 100%;
    height: 100vh;
    max-width: 375px;
    margin: auto;
    background: #f1f1f1;
    padding-top: 4px;
    overflow: auto;
  
    .box{
      .title{
        font-size: 14.58px;
        font-weight: 500;
        text-align: center;
        color: #000000;
      }
      .time{
        height: 9.72px;
        font-size: 12.5px;
        font-weight: 400;
        color: #9f9f9f;
        line-height: 7.99px;
        text-align: center;
      }
    }
    .title {
      width: 100%;
      text-align: center;
      font-size: 20px;
      font-family: Source Han Sans CN, Source Han Sans CN-Bold;
      font-weight: 700;
      color: black;
      line-height: 36px;
    }
    .content{
      margin: 10px 20px;
      color: #666666;
      font-weight: 500;
      font-size: 12.5px;
      line-height: 1.5;
      p,span {
        background: #f1f1f1 !important;
      }
      img{
        width: 100%;
      }
  
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }
  </style>
  